import { useState } from "react";
import { downloadLessonSchedule, type LessonScheduleScope } from "../../api/reports";
import "./ScheduleExportButton.css";

type Props = {
  scope: LessonScheduleScope;
  startDate: string;
  endDate: string;
  instructorIds?: string[];
  className?: string;
};

function ExportIcon() {
  return (
    <svg
      className="kp-schedule-export__icon"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
    >
      <path
        d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6Z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path
        d="M14 2v6h6M12 18v-6M9 15l3 3 3-3"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ScheduleExportButton({
  scope,
  startDate,
  endDate,
  instructorIds,
  className,
}: Props) {
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const run = async () => {
    setDownloading(true);
    setError(null);
    try {
      await downloadLessonSchedule("xlsx", { scope, startDate, endDate, instructorIds });
    } catch (err) {
      setError(err instanceof Error ? err.message : "Program indirilemedi.");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className={`kp-schedule-export${className ? ` ${className}` : ""}`}>
      <button
        type="button"
        className="kp-schedule-export__btn"
        onClick={run}
        disabled={downloading}
        title="Görüntülediğiniz dönemin ders programını Excel olarak indirir"
      >
        <ExportIcon />
        <span>{downloading ? "Hazırlanıyor…" : "Excel'e Aktar"}</span>
      </button>
      {error && <span className="kp-schedule-export__err">{error}</span>}
    </div>
  );
}
